import eventBus from './EventBus';

class ViewManager {
  constructor(canvasManager) {
    this.canvasManager = canvasManager;
    this.views = [];
    this.activeIndex = 0;
  }

  init() {
    this.views = [
      {
        name: 'Vorderseite',
        canvasJSON: null,
        preview: null,
      },
    ];
    this._emitChange();
  }

  addView(name = '') {
    const index = this.views.length;
    const viewName = name || `Ansicht ${index + 1}`;
    this._saveCurrentView();
    this.views.push({
      name: viewName,
      canvasJSON: null,
      preview: null,
    });
    this.activeIndex = index;
    this.canvasManager.canvas.clear();
    this.canvasManager.canvas.setBackgroundColor('#ffffff', () => {
      this.canvasManager.drawBleedLines();
      this.canvasManager.canvas.renderAll();
    });
    this._emitChange();
    return index;
  }

  async switchView(index) {
    if (index === this.activeIndex) return;
    if (index < 0 || index >= this.views.length) return;
    this._saveCurrentView();
    this.activeIndex = index;
    const view = this.views[index];
    if (view.canvasJSON) {
      await this.canvasManager.loadJSON(view.canvasJSON);
    } else {
      this.canvasManager.canvas.clear();
      this.canvasManager.canvas.setBackgroundColor('#ffffff', () => {
        this.canvasManager.drawBleedLines();
        this.canvasManager.canvas.renderAll();
      });
    }
    this._emitChange();
  }

  removeView(index) {
    if (this.views.length <= 1) return;
    if (index < 0 || index >= this.views.length) return;
    this.views.splice(index, 1);
    if (this.activeIndex >= this.views.length) {
      this.activeIndex = this.views.length - 1;
    }
    if (index === this.activeIndex || this.activeIndex >= this.views.length) {
      const view = this.views[this.activeIndex];
      if (view.canvasJSON) {
        this.canvasManager.loadJSON(view.canvasJSON);
      }
    }
    this._emitChange();
  }

  renameView(index, name) {
    if (index < 0 || index >= this.views.length) return;
    this.views[index].name = name;
    this._emitChange();
  }

  getViews() {
    return this.views.map((v, i) => ({
      name: v.name,
      index: i,
      active: i === this.activeIndex,
      hasContent: !!v.canvasJSON,
    }));
  }

  getActiveIndex() {
    return this.activeIndex;
  }

  getAllViewsJSON() {
    this._saveCurrentView();
    return this.views.map((v) => ({
      name: v.name,
      canvasJSON: v.canvasJSON,
    }));
  }

  async loadAllViews(viewsData) {
    this.views = viewsData.map((v) => ({
      name: v.name,
      canvasJSON: v.canvasJSON,
      preview: null,
    }));
    this.activeIndex = 0;
    if (this.views[0].canvasJSON) {
      await this.canvasManager.loadJSON(this.views[0].canvasJSON);
    }
    this._emitChange();
  }

  _saveCurrentView() {
    if (!this.canvasManager.canvas) return;
    const json = this.canvasManager.getJSON();
    this.views[this.activeIndex].canvasJSON = json;
    try {
      this.views[this.activeIndex].preview = this.canvasManager.canvas.toDataURL({
        format: 'png',
        quality: 0.3,
        multiplier: 0.2,
      });
    } catch (e) {
      // Preview generation may fail with CORS images
    }
  }

  _emitChange() {
    eventBus.emit('views:changed', {
      views: this.getViews(),
      activeIndex: this.activeIndex,
    });
  }
}

export default ViewManager;
